import React, { useContext } from 'react';
import cls from 'classnames';

import Circle from '../../Icon/Circle';
import { MyContext } from '../../../../config/context-manager';

import styles from './style.module.scss';

type ThemeType = 'default' | 'allWhite' | 'green';
interface TitleProps {
  className?: string;
  theme?: ThemeType;
}

const Title: React.FC<TitleProps> = ({ className, children, theme = 'default' }) => {
  const { locale } = useContext(MyContext);
  const classes = cls(styles.container, className, styles[`${theme}`], {
    [styles.localeEn]: locale === 'en',
  });

  return (
    <div className={classes}>
      <div className={styles.content}>
        <h3>{children}</h3>
        <span className={styles.round}>
          <Circle className={styles.circleSLeft} />
          <Circle className={styles.circleBLeft} />
        </span>
        <span className={styles.roundRight}>
          <Circle className={styles.circleBRight} />
          <Circle className={styles.circleSRight} />
        </span>
      </div>
    </div>
  );
};

export default Title;
